import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../../csr-web-api.service';
import { CareerRoleAdminActionsService } from '../shared/career-role-admin-actions.service';
import { JobsPanelComponent } from '../jobs-panel/jobs-panel.component';

@Component({
  selector: 'app-career-role-admin-shell',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    RouterOutlet,
    RouterLink,
    JobsPanelComponent
  ],
  templateUrl: './career-role-admin-shell.component.html',
  styleUrl: './career-role-admin-shell.component.scss'
})
export class CareerRoleAdminShellComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly api = inject(CsrWebApiService);
  private readonly actions = inject(CareerRoleAdminActionsService);
  private readonly snackBar = inject(MatSnackBar);

  busy = false;

  readonly toolLinks = [
    { label: 'Skill de-duplication', path: '/admin/skill-deduplication' },
    { label: 'Archived skills', path: '/admin/archived-skills' },
    { label: 'Resource management', path: '/admin/resource-management' },
    { label: 'Catalog collection', path: '/admin/catalog-collection' },
    { label: 'Zero-resource sweep', path: '/admin/zero-resource-sweep' },
    { label: 'Topic dependency backfill', path: '/admin/topic-dependency-backfill' },
    { label: 'Background jobs', path: '/admin/background-jobs' }
  ];

  get contextRoleSlug(): string | undefined {
    let current: ActivatedRoute | null = this.route;
    while (current) {
      const slug = current.snapshot.paramMap.get('slug');
      if (slug) {
        return slug;
      }
      current = current.firstChild;
    }
    return undefined;
  }

  backToAdmin(): void {
    void this.router.navigate(['/admin']);
  }

  goHome(): void {
    void this.router.navigate(['/admin/career-roles']);
  }

  async removeSoftSkillsCategory(): Promise<void> {
    if (
      !confirm(
        'Remove all skills with category "Soft Skills" from EVERY role in the database? This cannot be undone from this UI.'
      )
    ) {
      return;
    }
    this.busy = true;
    try {
      const result = await firstValueFrom(
        this.api.removeCareerRoleSkillsByCategory({ category: 'Soft Skills' })
      );
      this.snackBar.open(
        `Removed Soft Skills from ${result.rolesTouched} role(s): core=${result.coreRowsRemoved}, focus=${result.focusRowsRemoved}`,
        'Close',
        { duration: 6000 }
      );
    } catch (error) {
      this.snackBar.open(this.actions.errorMessage(error), 'Close', { duration: 5000 });
    } finally {
      this.busy = false;
    }
  }
}